module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-467.c832c16.woff2";